import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Select} from 'components/partials/select';
import ReactPaginate from 'react-paginate';
import {ShowIf, stripTags} from 'components/utils';
import {Businesses} from 'api';
import {LoadingPage} from 'components/loading-page';
import {UploadImage} from 'components/UI/Image';
import './style.scss';

class QuangNgaiBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      cites: [
        {key: 'option 1', value: 1},
        {key: 'option 2', value: 2}
      ],
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: true,
      search: ''
    };
    this.onChange = this.onChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.getBusinesses = this.getBusinesses.bind(this);
  }

  getBusinesses() {
    this.setState({data: []});
    this.getList();
  }

  componentDidMount() {
    this.getList();
  }

  contactBusiness(name) {
    this.props.history.push({
      pathname: `/doanh-nghiep/${name}`,
      state: {
        view: 'contact'
      }
    });
  }

  getList() {
    this.setState({isLoading: true});
    const params = {
      q: stripTags(this.state.search),
      limit: this.state.limit,
      offset: this.state.skip
    };

    Businesses.actions.search.request(params).then((response) => {
      if (response && response.data) {
        let businesses = [];
        response.data.results.map((item, idx) => {
          businesses.push(item);
        });
        this.setState({
          data: businesses,
          isLoading: false,
          count: response.data.total
        });

        console.log(businesses);
      }
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onPageChange(page) {
    this.setState({skip: page.selected * this.state.limit}, () => {
      this.getList();
    });
  }

  render() {
    const {count, limit, isLoading} = this.state;
    const totalPage = Math.ceil(count / limit);
    return (
      <div className="center quangngai-businesses">
        <LoadingPage isShow={isLoading} />
        <div className="wrap-breadcrumb">
          <div className="breadcrumb">
            <Link className='breadcrumb-link' to="/">Trang chủ</Link>
          </div>
          <div className="breadcrumb">
            <span className="breadcrumb-slash">/</span>
            <span>Doanh nghiệp</span>
          </div>
        </div>
        <section className="advanced-search">
          {/* <div className='wrap-advanced-search'>
            <h2 className='advanced-search-title'>Lọc theo</h2>
            <Select data={this.state.cites} placeHolder='Thành phố' text='key' keyName='value'/>
            <Select data={this.state.cites} placeHolder='Tất cả ngành nghề' text='key' keyName='value'/>
          </div> */}
          <div className="wrap-advanced-search search-box">
            <input name="search" value={this.state.search} onChange={this.onChange} type="text" placeholder="Tên doanh nghiệp..." autoComplete="off"/>
            <button type="button" onClick={this.getBusinesses}><i className="fa fa-search"/>Tìm kiếm</button>
          </div>
        </section>
        <div className="business-list">
          {
            this.state.data.map((item, i) => {
              return (
                <div className="business-item">
                  <Link className="detail" to={`/doanh-nghiep/${item.nameSlug}`}>
                    <UploadImage type="BUSINESS" transform="crop" className='business-logo' width="140" height="120" image={item.logo}/>
                  </Link>
                  <div className="business-info">
                    <span className="name">{item.name}</span>
                    <span className="text">{item.address}</span>
                  </div>
                  <div className="business-contact">
                    <span><strong>Mã số thuế</strong>: {item.taxCode}</span>
                    <span><strong>Điện thoại</strong>: (+84) {item.phone}</span>
                    <span><strong>Email</strong>: {item.email}</span>
                  </div>
                  <div className="business-action">
                    <Link className="detail" to={`/doanh-nghiep/${item.nameSlug}`}>Xem chi tiết</Link>
                    <button onClick={this.contactBusiness.bind(this, item.nameSlug)} className="send-request" type="button">Liên hệ</button>
                  </div>
                </div>
              );
            })
          }
          <ShowIf condition={this.state.data.length > 0}>
            <ReactPaginate previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={<a href="javascript:void(0)">...</a>}
              breakClassName={"break-me"}
              pageCount={totalPage - 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={this.onPageChange}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"} />
          </ShowIf>
        </div>
      </div>
    );
  }
}

export default withRouter(QuangNgaiBusiness);



// WEBPACK FOOTER //
// ./components/business/quangngai-business/QuangNgaiBusiness.jsx